import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import LinkButton from '../atoms/button/LinkButton';
import RoomStateLabel from '../atoms/label/Label';
import PriceText from '../atoms/text/Price';
import PriceBlock from '../molecules/PriceBlock';

const PlanInfo = ({
  people, startDate, stayNights, handleSelectButton, totalAmount, adultPrice, stocks,
}) => {

  const makePeopleText = (people) => {
    let text = '';
    const { adult, childrenA, childrenB, childrenC, children2 } = people;
    if (adult) {
      text += `大人${adult}名`;
    }
    if (childrenA && childrenA !== '0') {
      text += `こども(6〜11歳)${childrenA}名`;
    }
    if (childrenB && childrenB !== '0') {
      text += `こども(3〜5歳)${childrenB}名`;
    }
    if (childrenC && childrenC !== '0') {
      text += `こども(3〜5歳)(寝具なし)${childrenC}名`;
    }
    if (children2 && children2 !== '0') {
      text += `こども(2歳)${children2}名`;
    }

    return text;
  };

  const peopleText = makePeopleText(people);

  const dateFormat = 'YYYY年MM月DD日';
  const startDateText = moment(startDate).format(dateFormat).toString();
  const endDateText = moment(startDate).add(stayNights, 'days').format(dateFormat).toString();

  const roomStateLittle = stocks < 7;
  const roomStateLabelColor = roomStateLittle ? 'red' : 'gray';
  const roomStateLabelText = roomStateLittle ? '空室わずか' : '空室あり';

  return (
    <React.Fragment>
      <div className="planInfo">
        <div className="planInfoItems">
          <div className="planInfoLeft">
            <div className="text">
              {`宿泊日 ${startDateText}〜${endDateText}(${stayNights}泊 ${peopleText})`}
            </div>
          </div>
          <div className="planInfoRight">
            <div className="RecommendPlanLabel">
              <RoomStateLabel color={roomStateLabelColor}>{roomStateLabelText}</RoomStateLabel>
            </div>
          </div>
        </div>
        <div className="planInfoNote">※旅行代金は往復航空機＋宿泊代金となります。</div>
        <div className="priceBlockWrapper">
          <PriceBlock priceTotal={totalAmount} adultPrice={adultPrice} />
          <LinkButton buttonType="cta" onClick={handleSelectButton}>このプランを選択</LinkButton>
        </div>
      </div>
      <div className="planSelectBlock">
        <div className="planSelectBlockDate">
          <div className="planSelectBlockDateItem">宿泊日</div>
          <div className="planSelectBlockDateItem">
            {`${startDateText}〜${endDateText}`}
            <small className="planSelectBlockDateItemSmall">{`(${peopleText} ${stayNights}泊)`}</small>
          </div>
        </div>
        <div className="planSelectNote">※旅行代金は往復航空機＋宿泊代金となります。</div>
        <div className="planSelectBlockPrice">
          <div className="planSelectBlockPriceItem">
            <div className="planSelectBlockPriceItemInner">
              <div className="planSelectBlockPriceItemTitle">大人１名あたり料金</div>
              <div className="planSelectBlockPriceItemNumber">
                <PriceText>{adultPrice.toLocaleString()}円</PriceText>
              </div>
            </div>
            <div className="planSelectBlockPriceItemInner">
              <div className="planSelectBlockPriceItemTitle">合計料金</div>
              <div className="planSelectBlockPriceItemNumber">
                <PriceText priceType="red">{totalAmount.toLocaleString()}円</PriceText>
              </div>
            </div>
          </div>
        </div>
        <div className="planSelectBlockLabel">
          <RoomStateLabel color={roomStateLabelColor}>{roomStateLabelText}</RoomStateLabel>
        </div>
        <div className="planSelectBlockButton">
          <LinkButton buttonType="cta" onClick={handleSelectButton}>このプランを選択</LinkButton>
        </div>
      </div>
    </React.Fragment>
  );
};

PlanInfo.propTypes = {
  people: PropTypes.object.isRequired,
  startDate: PropTypes.string.isRequired,
  stayNights: PropTypes.number.isRequired,
  handleSelectButton: PropTypes.func.isRequired,
  totalAmount: PropTypes.number.isRequired,
  adultPrice: PropTypes.number.isRequired,
  stocks: PropTypes.number.isRequired,
};

export default PlanInfo;
